<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.24 4.42578C13.079 5.26497 13.6502 6.33408 13.8816 7.49791C14.1129 8.66174 13.994 9.86804 13.5398 10.9643C13.0856 12.0605 12.3166 12.9975 11.3299 13.6567C10.3433 14.3159 9.18331 14.6677 7.99671 14.6677C6.8101 14.6677 5.65014 14.3159 4.66349 13.6567C3.67684 12.9975 2.9078 12.0605 2.45362 10.9643C1.99943 9.86804 1.8805 8.66174 2.11185 7.49791C2.3432 6.33408 2.91445 5.26497 3.75337 4.42578"
      stroke="red"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 1.33203V7.9987"
      stroke="red"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLogOut',
};
</script>

<style></style>
